import { object, string } from 'yup';

export const NoteSchema = ({ t }) => object().shape({
  description: string().trim().required().label(t('shared.forms.validation.description')),
});
